import React from 'react';
import Loading from '../components/Layout/Loading';
import SignUpSelect from '../components/SignUpV2/SignUpSelect';
import routes from '../constants/routes';
import { SignupType } from '../model/SignupType';
import authService from '../services/auth';
import location from '../services/location';
import pendo from '../services/pendo';
import { parse } from '../services/queryString';
import { push } from '../services/routing';

/**
 * @deprecated
 */
export class SignUpRoute extends React.PureComponent {
    state = {
        error: undefined,
        isLoading: true,
    };

    async componentDidMount() {
        const params = parse(location.search);
        if (params.new_signup === undefined) {
            push(routes.SIGN_UP_SELECTION, { new_signup: '1' });
        }
        try {
            await authService.getProfile();
            push(routes.SIGN_IN);
        } catch (error) {
            if (error.message === 'USER_NOT_LOGGED_IN') {
                pendo.trackEvent(pendo.buildAnonymousVisitor(), 'Old Sign Up - Sign Up Selection Viewed');
                this.setState({ isLoading: false });
            } else {
                this.setState({ error: error.message });
            }
        }
    }

    render() {
        const { error, isLoading } = this.state;
        if (error) {
            // Delegate error displaying to ErrorBoundary
            throw error;
        }
        if (isLoading) {
            return <Loading />;
        }
        const params = parse(location.search);
        return <SignUpSelect signupType={params.signupType as SignupType} />;
    }
}

export default SignUpRoute;
